export interface RouteType {
    module_code: string;
    path: string;
    title: string;
    permission: string[];
    main_module_code?: string;
}

export interface SubRouteType extends RouteType {
    main_module_code: string;
    display: boolean;
}

export interface MainRouteType extends RouteType {
    fontIcon: string;
    icon: string;
    subMenu: SubRouteType[];
    customIcon?: string;
}

export const mainRoutesConfig: MainRouteType[] = [
    {
        module_code: "DASHBOARD",
        path: "/dashboard",
        title: "แดชบอร์ด",
        fontIcon: "bi-speedometer2",
        icon: "bi bi-speedometer2",
        subMenu: [],
        permission: [],
    },
    {
        module_code: "CATALOG",
        path: "/catalog",
        title: "แค็ตตาล็อก",
        fontIcon: "bi-basket3-fill",
        icon: "bi bi-basket3-fill",
        subMenu: [],
        permission: [],
    },
    {
        module_code: "CUSTOMER",
        path: "/customer",
        title: "ลูกค้า",
        fontIcon: "bi-people",
        icon: "bi bi-people",
        subMenu: [],
        permission: [],
    },
    {
        module_code: "EMPLOYEE",
        path: "/employee",
        title: "พนักงาน",
        fontIcon: "bi-people",
        icon: "bi bi-people",
        subMenu: [],
        permission: [],
    },
    {
        module_code: "ORDER",
        path: "/order",
        title: "ออเดอร์",
        fontIcon: "bi-receipt",
        icon: "bi bi-receipt",
        subMenu: [],
        permission: [],
    },
    {
        module_code: "INVENTORY",
        path: "/stock",
        title: "สต็อก",
        fontIcon: "bi-box-seam",
        icon: "bi bi-box-seam",
        subMenu: [],
        permission: [],
    },
    {
        module_code: "PURCHASE",
        path: "/purchase",
        title: "จัดซื้อ",
        fontIcon: "bi-cart",
        icon: "bi bi-cart",
        subMenu: [],
        permission: [],
    },
    {
        module_code: "COST_LEDGER",
        path: "/cost_ledger",
        title: "ต้นทุน",
        fontIcon: "bi-cash-stack",
        icon: "bi bi-cash-stack",
        subMenu: [],
        permission: [],
    },
    {
        module_code: "REPORTS",
        path: "/report",
        title: "รายงาน",
        fontIcon: "bi-bar-chart-line",
        icon: "bi bi-bar-chart-line",
        subMenu: [],
        permission: [],
    },
    {
        module_code: "TRANSPORT",
        path: "/transport",
        title: "ขนส่ง",
        fontIcon: "bi-truck",
        icon: "bi bi-truck",
        subMenu: [],
        permission: [],
    },
    {
        module_code: "SETTING",
        path: "/setting",
        title: "ตั้งค่า",
        fontIcon: "bi-gear",
        icon: "bi bi-gear",
        subMenu: [],
        permission: [],
    },
]

export const subRoutesConfig: SubRouteType[] = [
    {
        // Rendered as the dedicated top-level Dashboard item in SidebarMenuMain,
        // not as a collapsible group — hence display: false.
        module_code: "DASHBOARD_MAIN",
        main_module_code: "DASHBOARD",
        path: "/dashboard",
        title: "แดชบอร์ดหลัก",
        permission: [],
        display: false
    },
    {
        module_code: "BUSINESS_LIST",
        main_module_code: "CATALOG",
        path: "/business/business_list",
        title: "ธุรกิจ",
        permission: [],
        display: true
    },
    {
        module_code: "MENU_LIST",
        main_module_code: "CATALOG",
        path: "/menu/menu_list",
        title: "เมนู",
        permission: [],
        display: true
    },
    {
        module_code: "PACKAGE_LIST",
        main_module_code: "CATALOG",
        path: "/package/package_list",
        title: "แพ็กเกจ",
        permission: [],
        display: true
    },
    {
        module_code: "CATEGORY_LIST",
        main_module_code: "CATALOG",
        path: "/category/category_list",
        title: "หมวดหมู่",
        permission: [],
        display: true
    },
    {
        module_code: "INGREDIENT_LIST",
        main_module_code: "CATALOG",
        path: "/ingredient/ingredient_list",
        title: "วัตถุดิบ",
        permission: [],
        display: true
    },
    {
        module_code: "BOM_LIST",
        main_module_code: "CATALOG",
        path: "/bom/bom_list",
        title: "สูตรการผลิต (BoM)",
        permission: [],
        display: true
    },
    {
        module_code: "ORDER_LIST",
        main_module_code: "ORDER",
        path: "/order/order_list",
        title: "รายการออเดอร์",
        permission: [],
        display: true
    },
    {
        module_code: "COOKING_ORDER_LIST",
        main_module_code: "ORDER",
        path: "/cooking_order/cooking_order_list",
        title: "ใบสั่งทำอาหาร",
        permission: [],
        display: true
    },
    {
        module_code: "WORK_CONSOLE",
        main_module_code: "ORDER",
        path: "/cooking_order/work_console",
        title: "คอนโซลครัว",
        permission: [],
        display: false
    },
    {
        module_code: "COMMAND_CENTER",
        main_module_code: "ORDER",
        path: "/cooking_order/command_center",
        title: "Command Center",
        permission: [],
        display: true
    },
    {
        module_code: "STOCK_ON_HAND",
        main_module_code: "INVENTORY",
        path: "/stock/on_hand",
        title: "สต็อกคงเหลือ",
        permission: [],
        display: true
    },
    {
        module_code: "STOCK_MOVEMENTS",
        main_module_code: "INVENTORY",
        path: "/stock/movements",
        title: "ประวัติเคลื่อนไหว",
        permission: [],
        display: true
    },
    {
        module_code: "STOCK_TRANSFER_LIST",
        main_module_code: "INVENTORY",
        path: "/stock_transfer/list",
        title: "โอนสต็อก",
        permission: [],
        display: true
    },
    {
        module_code: "STOCK_COUNT_LIST",
        main_module_code: "INVENTORY",
        path: "/stock_count/list",
        title: "ตรวจนับสต๊อก",
        permission: [],
        display: true
    },
    {
        module_code: "VENDOR_LIST",
        main_module_code: "PURCHASE",
        path: "/vendor/vendor_list",
        title: "ผู้ขาย",
        permission: [],
        display: true
    },
    {
        module_code: "PURCHASE_ORDER_LIST",
        main_module_code: "PURCHASE",
        path: "/purchase_order/po_list",
        title: "ใบสั่งซื้อ",
        permission: [],
        display: true
    },
    {
        module_code: "PURCHASE_ORDER_BATCH",
        main_module_code: "PURCHASE",
        path: "/purchase_order/batch_receive",
        title: "รับสินค้ารวมเช้า",
        permission: [],
        display: true
    },
    {
        module_code: "VENDOR_CREDIT_NOTE",
        main_module_code: "PURCHASE",
        path: "/vendor_credit_note/credit_note_list",
        title: "ใบลดหนี้ผู้ขาย",
        permission: [],
        display: true
    },
    // {
    //     module_code: "PNL_DASHBOARD",
    //     main_module_code: "COST_LEDGER",
    //     path: "/cost_ledger/pnl",
    //     title: "P&L Dashboard",
    //     permission: [],
    //     display: true
    // },
    // {
    //     module_code: "COST_RULE_LIST",
    //     main_module_code: "COST_LEDGER",
    //     path: "/cost_ledger/rules",
    //     title: "Cost Rules",
    //     permission: [],
    //     display: true
    // },
    // {
    //     module_code: "COST_EVENT_LIST",
    //     main_module_code: "COST_LEDGER",
    //     path: "/cost_ledger/events",
    //     title: "Cost Events",
    //     permission: [],
    //     display: true
    // },
    // {
    //     module_code: "ALLOCATION_RULE_LIST",
    //     main_module_code: "COST_LEDGER",
    //     path: "/cost_ledger/allocation_rules",
    //     title: "Allocation Rules",
    //     permission: [],
    //     display: true
    // },
    {
        module_code: "EMPLOYEE_LIST",
        main_module_code: "EMPLOYEE",
        path: "/employee/employee_list",
        title: "รายชื่อพนักงาน",
        permission: [],
        display: true
    },
    {
        module_code: "PAYROLL_IMPORT",
        main_module_code: "EMPLOYEE",
        path: "/payroll/import",
        title: "นำเข้าเงินเดือน",
        permission: [],
        display: true
    },
    // {
    //     module_code: "EMPLOYEE_SAL",
    //     main_module_code: "EMPLOYEE",
    //     path: "/employee/employee_salary_history",
    //     title: "เงินเดือนพนักงาน",
    //     permission: [],
    //     display: true
    // },
    {
        module_code: "ROLE_MANAGEMENT",
        main_module_code: "SETTING",
        path: "/setting/role_management",
        title: "จัดการสิทธิ์ผู้ใช้งาน",
        permission: [],
        display: true
    },
    {
        module_code: "MODULE_MANAGEMENT",
        main_module_code: "SETTING",
        path: "/setting/module_management",
        title: "จัดการโมดูล",
        permission: [],
        display: true
    },
    {
        module_code: "USER_MANAGEMENT",
        main_module_code: "SETTING",
        path: "/setting/user_management",
        title: "จัดการผู้ใช้",
        permission: [],
        display: true
    },
    {
        module_code: "DOCUMENT_CODE",
        main_module_code: "SETTING",
        path: "/setting/document_code",
        title: "จัดการเลขที่เอกสาร",
        permission: [],
        display: true
    },
    {
        module_code: "CUSTOMER_LIST",
        main_module_code: "CUSTOMER",
        path: "/customer/customer_list",
        title: "รายชื่อลูกค้า",
        permission: [],
        display: true
    },
    {
        module_code: "UNIT_GROUP_LIST",
        main_module_code: "SETTING",
        path: "/setting/unit_group_list",
        title: "จัดการกลุ่มหน่วยนับ",
        permission: [],
        display: true
    },
    {
        module_code: "SYSTEM_SETTING",
        main_module_code: "SETTING",
        path: "/setting/system_setting",
        title: "การตั้งค่าระบบ",
        permission: [],
        display: true
    },
    {
        module_code: "IMPORT",
        main_module_code: "SETTING",
        path: "/setting/import",
        title: "นำเข้าข้อมูล",
        permission: [],
        display: true
    },
    {
        module_code: "REPORTS_RUN",
        main_module_code: "REPORTS",
        path: "/report/index",
        title: "ภาพรวมรายงาน",
        permission: [],
        display: true
    },
    {
        module_code: "REPORTS_RUN",
        main_module_code: "REPORTS",
        path: "/report/purchase_vendor",
        title: "ยอดซื้อตามผู้จำหน่าย",
        permission: [],
        display: false
    },
    {
        module_code: "REPORTS_RUN",
        main_module_code: "REPORTS",
        path: "/report/credit_note",
        title: "ใบลดหนี้ผู้จำหน่าย",
        permission: [],
        display: false
    },
    {
        module_code: "REPORTS_RUN",
        main_module_code: "REPORTS",
        path: "/report/stock_movement",
        title: "การเคลื่อนไหวสต็อก",
        permission: [],
        display: false
    },
    {
        module_code: "REPORTS_RUN",
        main_module_code: "REPORTS",
        path: "/report/stock_waste",
        title: "การสูญเสียวัตถุดิบ",
        permission: [],
        display: false
    },
    {
        module_code: "REPORTS_RUN",
        main_module_code: "REPORTS",
        path: "/report/order_margin",
        title: "กำไรขั้นต้นต่อออเดอร์",
        permission: [],
        display: false
    },
    {
        module_code: "REPORTS_RUN",
        main_module_code: "REPORTS",
        path: "/report/cko_cost",
        title: "ต้นทุนการผลิต (CKO)",
        permission: [],
        display: false
    },
    {
        module_code: "REPORTS_RUN",
        main_module_code: "REPORTS",
        path: "/report/sales_summary",
        title: "ยอดขายสรุป",
        permission: [],
        display: false
    },
    {
        module_code: "REPORTS_RUN",
        main_module_code: "REPORTS",
        path: "/report/sales_menu",
        title: "ยอดขายตามเมนู",
        permission: [],
        display: false
    },
    {
        module_code: "REPORTS_RUN",
        main_module_code: "REPORTS",
        path: "/report/sales_customer",
        title: "ยอดขายตามลูกค้า",
        permission: [],
        display: false
    },
    {
        module_code: "REPORTS_RUN",
        main_module_code: "REPORTS",
        path: "/report/stock_balance",
        title: "สต็อกคงเหลือ",
        permission: [],
        display: false
    },
    {
        module_code: "TRANSPORT_ORDER_LIST",
        main_module_code: "TRANSPORT",
        path: "/transport/transport_order_list",
        title: "ใบสั่งขนส่ง",
        permission: [],
        display: true
    },
    {
        module_code: "VEHICLE_LIST",
        main_module_code: "TRANSPORT",
        path: "/transport/vehicle_list",
        title: "ยานพาหนะ",
        permission: [],
        display: true
    },
    {
        module_code: "DRIVER_LIST",
        main_module_code: "TRANSPORT",
        path: "/transport/driver_list",
        title: "พนักงานขับรถ",
        permission: [],
        display: true
    },
    {
        module_code: "SUBCONTRACT_LIST",
        main_module_code: "TRANSPORT",
        path: "/transport/subcontract_list",
        title: "ผู้รับเหมาขนส่ง",
        permission: [],
        display: true
    },
]
